import { render } from "./PreviewSend.vue?vue&type=template&id=ad99e53c"
import script from "./PreviewSend.vue?vue&type=script&lang=js"
export * from "./PreviewSend.vue?vue&type=script&lang=js"

import "./PreviewSend.vue?vue&type=style&index=0&id=ad99e53c&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__